import { message } from "antd";
import instance from "config/_axios";

// export const getOneSubjectCategory = async (id: number | null, path_prefix?: string) => {
//     try {
//         if (!id) {
//             return new Error("Id bo'yicha ma'lumot olinmadi !");
//         }

//         const response = await instance({ url: `/subject-categories/${id}${path_prefix ? "?" + path_prefix : ''}`, method: 'GET' })

//         if (response.data?.status === 1) {
//             return response.data?.data
//         } else {
//             return new Error(response.data?.message)
//         }
//     } catch (error: any) {
//         message.error(error?.response?.message)
//     }
// }

export const getAllSubjectCategories = async (perPage?: number|string, currentPage?: number|string, path_prefix?: string) => {
    try {

        const response = await instance({ url: `/subject-categories${path_prefix ? "?" + path_prefix : ''}`, method: "GET", params: { "per-page": perPage, page: currentPage } });

        if (response.data?.status === 1) {
            return response.data?.data
        } else {
            return new Error(response.data?.message)
        }
    } catch (error: any) {
        message.error(error?.response?.message)
    }
}